import ConfirmUnsavedChangesModal from '../ConfirmUnsavedChangesModal'

const textSpec = {
  title: 'Cancel Editing User',
  message: 'Are you sure? All changes will be lost.',
}

type PropTypes = {
  isOpen: boolean,
  onClose: () => void,
  onConfirm: () => void,
}

const ConfirmEditUserUnsavedChangesModal = ({ isOpen, onClose, onConfirm }: PropTypes) => {
  return (
    <ConfirmUnsavedChangesModal
      isOpen={isOpen}
      onClose={() => onClose()}
      onConfirm={() => onConfirm()}
      title={textSpec.title}
      message={textSpec.message}
    />
  )
}

export default ConfirmEditUserUnsavedChangesModal
